import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { addLifecycleResets } from "redux/rtk/extraReducersHelpers";

import { NOTIFICATION_LEVEL_SUCCESS } from "./actionLevels";
import {
  INotification,
  INotificationState,
  INotificationWithTimestamp,
  notificationsInitialState,
} from "./sliceTypes";
import {
  formatNotification,
  getExistingNotification,
  getUpdatedNotifications,
  isRecentDuplicate,
  updateNotificationsByLevel,
} from "./sliceUtils";

const addNotification = (
  state: INotificationState,
  notification: INotificationWithTimestamp,
) => {
  const existingNotification = getExistingNotification(
    state.allNotifications,
    notification,
  );

  if (isRecentDuplicate(notification, existingNotification)) {
    return;
  }

  state.allNotifications = getUpdatedNotifications(
    state.allNotifications,
    notification,
    existingNotification,
  );
  state.recentNotification = notification;
  state.byLevel = updateNotificationsByLevel(state.byLevel, notification);

  if (notification.level === NOTIFICATION_LEVEL_SUCCESS) {
    state.lastSuccessNotification = notification.timestamp;
  }
};

const notificationsSlice = createSlice({
  name: "notify",
  initialState: notificationsInitialState,
  reducers: {
    showNotification: {
      reducer: (state, action: PayloadAction<INotificationWithTimestamp>) => {
        addNotification(state, action.payload);
      },
      prepare: (notification: INotification) => ({
        payload: formatNotification(notification),
      }),
    },
  },
  extraReducers: (builder) => {
    addLifecycleResets(builder, notificationsInitialState);
  },
});

export const { showNotification } = notificationsSlice.actions;
export default notificationsSlice.reducer;
